import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
import App from "./components/App";
import Notifications from "./components/Notifications";
import Spinner from "./components/Spinner";
import * as serviceWorkerRegistration from "./Workbox/serviceWorkerRegistration";
import reportWebVitals from "./Workbox/reportWebVitals";
import swConfig from "./Workbox/swConfig";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

const isProduction = process.env.NODE_ENV !== "development";

if (isProduction) {
  Sentry.init({
    dsn: "https://8022dbe0c91247df804dd8e268c72a52@o1084220.ingest.sentry.io/6093925",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampler: (context) => {
      if (context.exception) return 1;
      return 0.2;
    },
  });
}

ReactDOM.render(
  <Root>
    <App />
    <Notifications />
    <Spinner />
  </Root>,
  document.querySelector("#root")
);

serviceWorkerRegistration.register(swConfig);
reportWebVitals();
